export const videoPath = {
  // ! This one is for videos, it has full Amazon S3 links, it's for dev and production, it just knows if you are on Marlin Servers or JMS servers. 
  // If you're in dev mode, it'll be undefined, so it'll return a hardcoded Marlin Amazon S3 URL
  data: function() {
    return {
      videoPath: window.assetPath ? window.assetPath + '/AwayFromHome' : 'https://s3.us-east-2.amazonaws.com/afh-www/site/assets/AwayFromHome'
    }
  },
};
